import { all, fork } from 'redux-saga/effects';

// public
import RegisterSaga from 'store/auth/register/saga';
import AuthSaga from 'store/auth/login/saga';
import ForgotSaga from 'store/auth/forgotPassword/saga';
import ResetPasswordSaga from 'store/auth/resetPassword/saga';
import ProfileSaga from 'store/auth/profile/saga';
import LayoutSaga from 'store/layout/saga';

import AddressSaga from 'store/address/saga';
import Administrator from 'store/administrator/saga';
import Banking from 'store/banking/saga';
import BookingReviewSaga from 'store/booking-review/saga';
import BookingSaga from 'store/booking/saga';
import LocationSaga from 'store/location/saga';
import MediaSaga from 'store/media/saga';
import PlaceSaga from 'store/place/saga';
import PlaceContactsSaga from 'store/place-contacts/saga';
import PromotionSaga from 'store/promotion/saga';
import RoomSaga from 'store/room/saga';
import RoomPriceTypeSaga from 'store/room-price-type/saga';
import RoomStatusSaga from 'store/location/room/saga';
import SettingSaga from 'store/setting/saga';
import updatePlaceOtaCredentialsSaga from 'store/update-place-ota-credentials/saga';
import customer from 'store/customer/saga';
import finance from 'store/finance/saga';
import invoice from 'store/invoice/saga';
import analytics from 'store/analytics/saga';
import discoverCategory from 'store/discover-category/saga';
import discoverProvince from 'store/discover-province/saga';
import discoverPlace from 'store/discover-place/saga';
import discoverReview from 'store/discover-review/saga';
import discoveryLocationSaga from 'store/discovery-loaction/saga';
import giftSaga from 'store/gift/saga';
import MarketSaga from 'store/market/saga';
import LandmarkSaga from 'store/landmark/saga';
import ManageAccountSaga from 'store/manageAccount/saga';
import manageCoinSaga from 'store/manageCoin/saga';
import managerPromotionSaga from 'store/manager-promotion/saga';
import managerOperationSaga from 'store/manager-operation/saga';
import managerReviewSaga from 'store/manager-review/saga';
import managerComplaintSaga from 'store/manager-complaint/saga';
import managerTcxhFeedbackSaga from 'store/manager-tcxh-feedback/saga';
import voucherSaga from 'store/voucher/saga';
import extranetNotificationSaga from 'store/extranet-notification/saga';
import chatSaga from 'store/chat/saga';
import revenueSaga from 'store/revenue/saga';
import vatSettingSaga from 'store/vat-setting/saga';

export default function* rootSaga() {
  yield all([
    // public
    fork(RegisterSaga),
    fork(AuthSaga),
    fork(ForgotSaga),
    fork(ResetPasswordSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),

    fork(MediaSaga),

    fork(BookingSaga),

    fork(AddressSaga),
    fork(Administrator),
    fork(Banking),
    fork(BookingReviewSaga),
    fork(LocationSaga),
    fork(PlaceSaga),
    fork(PlaceContactsSaga),
    fork(PromotionSaga),
    fork(RoomSaga),
    fork(RoomPriceTypeSaga),
    fork(RoomStatusSaga),
    fork(SettingSaga),
    fork(updatePlaceOtaCredentialsSaga),
    fork(customer),
    fork(finance),
    fork(invoice),
    fork(analytics),
    fork(discoverCategory),
    fork(discoverProvince),
    fork(discoverPlace),
    fork(discoverReview),
    fork(discoveryLocationSaga),
    fork(giftSaga),
    fork(MarketSaga),
    fork(LandmarkSaga),
    fork(ManageAccountSaga),
    fork(manageCoinSaga),
    fork(managerPromotionSaga),
    fork(managerOperationSaga),
    fork(managerReviewSaga),
    fork(managerComplaintSaga),
    fork(managerTcxhFeedbackSaga),
    fork(voucherSaga),
    fork(extranetNotificationSaga),
    fork(chatSaga),
    fork(revenueSaga),
    fork(vatSettingSaga),
  ]);
}
